import React from 'react';

// const Subheading = ({ text }) => {
//     return (
//         <h2 className="subheading">
//             {text}
//         </h2>
//     );
// };
const Subheading = React.forwardRef(({ text }, ref) => (
    <h2 className="subheading" ref={ref}>{text}</h2>
));


export default Subheading;
